import React from 'react';

const Footer = () => {
    return (
        <div>

            <p className='text-center pt-8 pb-4'>Copyright © 2023 - All right reserved by Md Yeasin</p>

        </div>
    );
};

export default Footer;